import last from 'lodash/last';

import { isParagraph } from '@lumapps/wrex-typography/utils/isParagraph';
import { Editor, Location } from '@lumapps/wrex/slate';
import { isElement } from '@lumapps/wrex/slate/utils/isElement';
import { Wrex } from '@lumapps/wrex/types';

/**
 * Check if current selection allows insertion of autocomplete.
 */
export function isAutocompleteAllowed({
    editor,
    at,
    isElementAllowed,
}: {
    editor: Editor;
    at?: Location | null;
    isElementAllowed?: (element?: Wrex.Element) => boolean;
}) {
    const location = at || editor.selection;
    // Editor cursor should be available.
    if (!location) {
        return false;
    }
    try {
        // Get last element of the current selection.
        const [lastElement] =
            last(
                Array.from(
                    Editor.nodes(editor, { at: Editor.end(editor, location), match: isElement, mode: 'lowest' }),
                ),
            ) || [];
        // Last element should be a paragraph (autocompleted elements are inserted at the end of the selection).
        return isElementAllowed ? isElementAllowed(lastElement) : isParagraph(lastElement);
    } catch (ignored) {
        return false;
    }
}
